import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73bd8a46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bike-station-connector text-sm" }
const _hoisted_2 = { class: "bike-station" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "station-dot" }, null, -1))
const _hoisted_4 = { class: "flex flex-column text-base" }
const _hoisted_5 = { class: "font-semibold" }
const _hoisted_6 = { class: "flex gap-2" }
const _hoisted_7 = { class: "flex align-items-center gap-1" }
const _hoisted_8 = { class: "flex align-items-center gap-1" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "station-connector-line" }, null, -1))
const _hoisted_10 = { class: "bike-station" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "station-dot" }, null, -1))
const _hoisted_12 = { class: "flex flex-column text-base" }
const _hoisted_13 = { class: "font-semibold" }
const _hoisted_14 = { class: "flex gap-2" }
const _hoisted_15 = { class: "flex align-items-center gap-1" }
const _hoisted_16 = { class: "flex align-items-center gap-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconBike = _resolveComponent("IconBike")!
  const _component_IconLock = _resolveComponent("IconLock")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.leg.start.bikeStation?.name), 1),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_IconBike, { class: "text-primary" }),
            _createElementVNode("span", null, _toDisplayString(_ctx.leg.start.bikeStation?.availableVehicles), 1)
          ]),
          _createTextVNode(" • "),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_IconLock, { class: "text-primary" }),
            _createElementVNode("span", null, _toDisplayString(_ctx.leg.start.bikeStation?.availableSpaces), 1)
          ])
        ])
      ])
    ]),
    _hoisted_9,
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.leg.end.bikeStation?.name), 1),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_IconBike, { class: "text-primary" }),
            _createElementVNode("span", null, _toDisplayString(_ctx.leg.end.bikeStation?.availableVehicles), 1)
          ]),
          _createTextVNode(" • "),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_IconLock, { class: "text-primary" }),
            _createElementVNode("span", null, _toDisplayString(_ctx.leg.end.bikeStation?.availableSpaces), 1)
          ])
        ])
      ])
    ])
  ]))
}